export default {"src":"/_next/static/media/DOOR.27c2549d.svg","height":18,"width":18};